import {ATLAS_DB, REALTIME_DB} from '@/config/firebase';
import {ref} from 'firebase/database';

export interface IRunway {
  availability: string;
  lda: string;
  runway: string;
  length?: string;
}

export interface IAirport {
  iata: string;
  airport: string;
  lat: string;
  long: string;
  colour: 'green' | 'amber' | 'red';
  dep_delay: string;
  arr_delay: string;
  arr_delay_colour: 'green' | 'amber' | 'red';
  dep_delay_colour: 'green' | 'amber' | 'red';
  dep_delay_trend: string;
  arr_delay_trend: string;
  metar_new: any;
  taf_new: any;
  wx: string;
  wx_category: string;
  vis: string;
  vis_trend: string;
  metar: string;
  taf: string;
  notams: INotamAI[];
  runway: IRunway[] | string;
  runway_in_use: string;
  RFFS: string;
  RFFS_colour: 'amber' | 'green';
  ATS: 'string';
  ATS_colour: 'amber' | 'green';
  Customs: string;
  Customs_colour: 'amber' | 'green';
  wx_colour: 'green' | 'amber' | 'red';
  vis_colour: 'green' | 'amber' | 'red';
  temperature?: string;
  country_code?: string;
  not_key_icao?: boolean;
  is_diversion?: boolean;
  historical_delay_v2: any;
}

export interface INotamAI {
  uuid: string;
  active: string;
  content: string;
  line?: string;
  category: string;
  graphical?: boolean;
  created: string;
  start_date: string;
  end_date: string;
  key_info: string;
  max_alt: string;
  min_alt: string;
  notamID: string;
  radius: string;
  coordinate: null | number[];
  area?: string;
  effectivity?: Array<[string, string]>;
  isEffective?: boolean;
  airport?: string;
  order?: number;
  relevant?: boolean;
  obst_coordinates?: Array<[number, number]>;
  isAutoFavorite?: boolean;
  raw?: string;
  taxiway_closures?: any;
  aircraft_applicability: string[];
  raw_effectivity?: string;
  fir: string;
  showSitMapBtn?: boolean;
  type: string;
}

export interface INote {
  _id?: string;
  pirepId: string;
  eventId: string;
  title: string;
  content: string;
  category?: string[]; // Hazard, Weather, ...
  phases: string[]; // Departure, Enroute, Arrival
  tags: string[]; // Terrain, Environment, ...
  includeCrew: boolean;
  shareLocation: string | undefined;
  isAircraft?: boolean; // true if it is aircraft note
  shareToCommunity: boolean; // true if it is shared to community (aabba)
  shareWithSelectedUser: boolean;
  userId: string;
  username: string;
  upvoteCount?: number;
  voted?: boolean;
  comments?: INoteComment[];
  isMapNote?: boolean;
  notamInfo?: {
    isEffective: boolean;
    content: string;
    notamID: string;
    created: string;
  };
  metarTafInfo?: {
    time: string;
    isMetar: boolean;
  };
  airport?: string;
  aircraft?: string;
  updatedAt?: string;
  createdAt?: string;
  favorites: Record<string, boolean>;
  votes: Record<string, boolean>;
  effectivity?: string;
  isEffective?: boolean;
}

export interface INoteComment {
  _id: string;
  content: string;
  userId: string;
  username: string;
  date: string;
}

export const allAirportRef = () => {
  return ref(REALTIME_DB, `${ATLAS_DB}/airports`);
};

export const allNotes = () => {
  return ref(REALTIME_DB, `${ATLAS_DB}/notes`);
};

export const NOTAMS_FILTER = [
  'All',
  'Runway',
  'Taxiway',
  'Approach',
  'Departure',
  'Navaids',
  'Obstacles',
  'Others'
];

export const FIR_NOTAMS_FILTER = [
  'All',
  'Procedures',
  'Danger Area',
  'Launch',
  'Firing',
  'Aerial Activity',
  'Others',
  'CPDLC',
  'GPS',
  'ADS',
  'CLOSURES'
];

export const BRIEFING_TAGS = ['Terrain', 'Environment', 'ATC', 'Others'];

export enum NOTE_CATEGORY {
  TERRAIN = 'Terrain',
  ENVIRONMENT = 'Environment',
  ATC = 'ATC',
  OTHERS = 'Others'
}

export type TAirportNote = {
  id: string;
  content: string;
  airport: string;
};
